module.exports = __webpack_public_path__ + "static/media/logo-portones.298e13f3.png";